module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (!_vm.href) ? _c('button', {
    staticClass: "md-button",
    class: [_vm.themeClass],
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.$emit('click', $event)
      }
    }
  }, [_c('md-ink-ripple', {
    attrs: {
      "md-disabled": _vm.disabled
    }
  }), _vm._v(" "), _vm._t("default")], true) : _c('a', {
    staticClass: "md-button",
    class: [_vm.themeClass],
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled,
      "target": _vm.target,
      "rel": _vm.newRel
    },
    on: {
      "click": function($event) {
        _vm.$emit('click', $event)
      }
    }
  }, [_c('md-ink-ripple', {
    attrs: {
      "md-disabled": _vm.disabled
    }
  }), _vm._v(" "), _vm._t("default")], true)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b3983a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b3983a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mdButton/mdButton.vue
// module id = 27
// module chunks = 3 26